<template>
  <div>
    <el-dialog
      :title="(form.id && !isCopy) ? '编辑活码' :  '新建活码'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      top="4vh"
      width="880px"
      class="form-dialog"
      :before-close="handleClose"
    >
      <div class="form-module">
        <p class="module-title">基础信息</p>
        <el-form ref="ruleform" :model="form" :rules="formRules" size="small" label-width="128px">
          <el-form-item label="渠道活码名称：" prop="name">
            <el-input v-model="form.name" maxlength="20" placeholder="请输入渠道活码名称" @input="isChange = false" />
          </el-form-item>
          <el-form-item label="客服人员：" prop="customerServiceType">
            <el-radio-group v-model="form.customerServiceType" @input="isChange = false">
              <el-radio :label="1">全天在线</el-radio>
              <el-radio :label="2">自动上下线</el-radio>
            </el-radio-group>
            <el-row v-if="form.customerServiceType === 1" class="item-explain">
              <el-col :span="4">
                <p class="label">全天在线：</p>
              </el-col>
              <el-col :span="20">
                <p class="content">在非工作周期内，学员添加为备选人员联系方式；</p>
              </el-col>
            </el-row>
            <el-row v-else-if="form.customerServiceType === 2" class="item-explain">
              <el-col :span="4">
                <p class="label">自动上下线：</p>
              </el-col>
              <el-col :span="20">
                <p class="content">1、可用于员工早晚班等不同上班时间段使用；</p>
                <p class="content">2、员工在非在线时间不再接待新学员；</p>
                <p class="content">3、在非工作周期、上线时间内，学员添加为备选人员联系方式；</p>
              </el-col>
            </el-row>
            <div v-for="(item, index) of salesGroup" :key="item.index" class="item-complement">
              <el-row type="flex" class="form-item-line">
                <p class="label">员工选择：</p>
                <el-button icon="el-icon-plus" type="primary" size="small" plain @click="toAddAcc(index)">添加成员</el-button>
                <el-button
                  v-if="index !== 0"
                  icon="el-icon-remove-outline"
                  type="text"
                  size="small"
                  style="margin-left: auto"
                  @click="delAcc(index)"
                >删除该工作周期</el-button>
              </el-row>
              <el-row v-show="item.sales.length" type="flex" class="form-item-line">
                <p class="label" />
                <el-tag
                  v-for="(p, i) of item.sales"
                  :key="p.userid"
                  size="small"
                  closable
                  effect="plain"
                  class="index-item"
                  @close="handleDelAcc(index, i)">
                  {{ p.name }}
                </el-tag>
              </el-row>
              <el-row type="flex" class="form-item-line">
                <p class="label">工作周期：</p>
                <el-select v-model="item.workCycle" multiple placeholder="请选择" style="width: 80%">
                  <el-option
                    v-for="(w, i) in weeks"
                    :key="i"
                    :label="w"
                    :value="i + 1">
                  </el-option>
                </el-select>
              </el-row>
              <el-row v-if="form.customerServiceType === 2" type="flex" class="form-item-line">
                <p class="lebal">上线时间：</p>
                <el-row type="flex">
                  <el-time-picker
                    v-model="item.startTime"
                    value-format="HH:mm"
                    :picker-options="{
                      format: 'HH:mm',
                      selectableRange: `00:00:00 - ${item.endTime || '23:59'}:59`
                    }"
                    placeholder="开始时间"
                    style="width: 120px"
                  />
                  <span>&emsp;-&emsp;</span>
                  <el-time-picker
                    v-model="item.endTime"
                    value-format="HH:mm"
                    :picker-options="{
                      format: 'HH:mm',
                      selectableRange: `${ item.startTime || '00:00' }:00 - 23:59:59`
                    }"
                    placeholder="结束时间"
                    style="width: 120px"
                  />
                </el-row>
              </el-row>
              <el-row type="flex" class="form-item-line">
                <p class="lebal">备选人员：</p>
                <el-button icon="el-icon-plus" type="primary" size="small" plain @click="toAddBackAcc(index)">添加成员</el-button>
              </el-row>
              <el-row v-show="backSales.length" type="flex" class="form-item-line">
                <p class="label"></p>
                <el-tag
                  v-for="p of backSales"
                  :key="p.userid"
                  size="small"
                  closable
                  effect="plain"
                  class="index-item"
                  @close="handleDelBackAcc">
                  {{ p.name }}
                </el-tag>
              </el-row>
            </div>
            <!-- <el-button
              v-if="form.customerServiceType === 2"
              type="text"
              icon="el-icon-circle-plus-outline"
              @click="handleAddGroup"
            >添加其他工作周期</el-button> -->
          </el-form-item>
          <!-- <el-form-item label="员工添加权重：">
            <el-switch
              v-model="form.addLimitFlag"
              :active-text="form.addLimitFlag === 2 ? '已开启' : '已关闭'"
              :active-value="2"
              :inactive-value="1"
            />
            <el-row class="item-explain">
              <el-col :span="4">
                <p class="label">员工添加权重：</p>
              </el-col>
              <el-col :span="20">
                <p class="content">开启后，根据所配置的权重进行线索分配，数字越大，分配的概率越高；未开启时，则按照线索轮巡分配；</p>
              </el-col>
            </el-row>
            <el-table v-show="form.addLimitFlag === 2" :data="sales" border size="small">
              <el-table-column align="center" label="销售姓名" prop="name" />
              <el-table-column align="center" label="销售手机号" prop="mobile" />
              <el-table-column align="center" label="企微账号状态">
                <template v-slot="{ row }">
                  <span v-if="row.status === 1">已激活</span>
                  <span v-else-if="row.status === 2">已禁用</span>
                  <span v-else-if="row.status === 4">未激活</span>
                  <span v-else-if="row.status === 5">退出企业</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="权重">
                <template slot="header">
                  <span>权重</span>
                  <el-tooltip :open-delay="200" placement="top">
                    <div slot="content" class="tooltip-content">可输入1-100的数字，数字越大，分配的概率越高；</div>
                    <i class="tooltip-index el-icon-question" />
                  </el-tooltip>
                </template>
                <template v-slot="{ row }">
                  <el-input-number v-model="row.weight" @change="weights = []" :min="1" :max="100" size="small" />
                </template>
              </el-table-column>
            </el-table>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="form-module">
        <p class="module-title">功能设置</p>
        <el-form :model="form" size="small" label-width="128px">
          <el-form-item label="自动通过好友：" prop="name">
            <el-switch
              v-model="form.autoThroughFriendFlag"
              :active-text="form.autoThroughFriendFlag === 2 ? '已开启' : '已关闭'"
              :active-value="2"
              :inactive-value="1"
               @change="isChange = false"
            />
            <el-row class="item-explain">
              <el-col :span="4">
                <p class="label">自动通过好友：</p>
              </el-col>
              <el-col :span="20">
                <p class="content">开启后学员添加销售后自动通过，状态为关闭时，需手动通过好友申请。</p>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="二维码封面预览：" prop="name">
            <el-row type="flex" align="bottom">
              <div class="pic" @click="previewDialog = true">
                <img src="../../../assets/images/preview_qrcode.png" style="width: 100%; height: 100%">
                <img v-if="form.logoUrl" :src="form.logoUrl" class="qr-logo">
              </div>
              <ImgUpload
                accept=".JPG, .jpg, .png, .PNG, .jpeg, .JPEG"
                :max="4"
                :size="5120"
                @input="onUpload"
              />
            </el-row>
            <p class="upload-tips">注意：此二维码仅展示预览效果，请勿直接使用</p>
          </el-form-item>
          <el-form-item label="设置欢迎语：" prop="">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              placeholder="请输入内容"
              v-model="form.welcomeContent"
              maxlength="1000"
              show-word-limit
              @input="isChange = false"
            />
          </el-form-item>
          <el-form-item label="备注：" prop="">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="200"
              show-word-limit
              @input="isChange = false"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleSave">保存活码</el-button>
        <el-button type="" size="small" @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 添加成员 -->
    <el-dialog
      title="添加成员"
      width="800px"
      :class="[currentIndex === 99999 && 'radio-select-table']"
      :visible.sync="dialogAccVisible"
      :close-on-click-modal="false"
      :before-close="handleCloseAcc"
    >
      <el-form :model="accFilter" class="filer" size="small" label-width="100px" inline>
        <el-form-item label="企微姓名：">
          <el-input v-model.trim="accFilter.names" maxlength="20" placeholder="请输入企微姓名" />
        </el-form-item>
        <el-form-item label="企微手机号：">
          <el-input v-model.trim="accFilter.mobiles" maxlength="11" placeholder="请输入企微手机号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">搜索</el-button>
          <el-button @click="handleResetFilter">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="tags">
        <div style="margin-bottom:10px">已选择{{ accSelection.length }}人：</div>
        <div v-for="(tag, index) in accSelection" :key="tag.userid">
          <el-tag style="margin:0 10px 10px 0;" size="mini" @close="handleDelSelection(tag)" v-if="index < 18" closable>
            {{tag.name}}
          </el-tag>
        </div>
        <div v-if="accSelection.length > 18">······</div>
      </div>
      <el-table
        ref='multipleTable'
        v-loading="accLoading"
        :data="accList"
        border size="small"
        @select="handleSelect"
        @select-all="handleSelectionAll"
      >
        <el-table-column type="selection" align="center" width="55" />
        <el-table-column align="center" label="企微姓名" prop="name" />
        <el-table-column align="center" label="企微手机号" prop="mobile" />
        <el-table-column align="center" label="别名" prop="alias" />
        <el-table-column align="center" label="企微账号状态">
          <template v-slot="{ row }">
            <span v-if="row.status === 1">已激活</span>
            <span v-else-if="row.status === 2">已禁用</span>
            <span v-else-if="row.status === 4">未激活</span>
            <span v-else-if="row.status === 5">退出企业</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="所在部门" prop="deptName" />
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="accFilter.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="accFilter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="accTotal"
        @size-change="handleSizeChangeAcc"
        @current-change="handleCurrentChangeAcc"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleSaveAcc">保存</el-button>
        <el-button type="" size="small" @click="handleCloseAcc">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="预览" :visible.sync="previewDialog" width="680px" class="preivew-dialog">
      <div class="pic preview">
        <img src="../../../assets/images/preview_qrcode.png" style="width: 100%; height: 100%">
        <img v-if="form.logoUrl" :src="form.logoUrl" class="qr-logo">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAccList, addQwLiveCode, getbindAccList, getSaleWeights } from '@/api/admin/saleQrcode.js'
import ImgUpload from '@/components/upload/file'
import { unique } from '@/utils/handle'

const group = function() {
  return {
    sales: [],
    workCycle: [],
    startTime: '',
    endTime: ''
  }
}

export default {
  name: 'LiveCodeManage',

  components: { ImgUpload },
  props: {
    classifyId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      weeks: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      weights: [],
      form: {
        name: '',
        customerServiceType: 1,
        addLimitFlag: 1,
        autoThroughFriendFlag: 2,
        logoUrl: '',
        remarks: '',
        welcomeContent: ''
      },
      formRules: {
        name: [
          { required: true, message: '请输入渠道活码名称', trigger: 'blur' }
        ]
      },
      salesGroup: [group()],
      backSales: [],
      sales: [],
      dialogAccVisible: false,
      currentIndex: 0,
      accFilter: {
        page: 1,
        limit: 10,
        names: '',
        mobiles: ''
      },
      accTotal: 0,
      accLoading: false,
      accList: [],
      accSelection: [],
      previewDialog: false,
      isCopy: false,
      isChange: true
    }
  },
  methods: {
    init(v) {
      if (v) {
        this.isCopy = v.isCopy
        this.handleEdit(v)
      } else {
        this.dialogVisible = true
      }
    },
    handleEdit(row) {
      // 获取客服人员数据 & 员工权重数据
      const params = {
        liveCodeId: row.id
      }
      this.form.id = row.id
      this.form.name = row.name
      if (row.alternateSaleId) {
        this.backSales = [{
          userid: row.alternateSaleId,
          name: row.alternateSaleName
        }]
      }
      this.form.customerServiceType = row.customerServiceType
      this.form.addLimitFlag = row.addLimitFlag
      this.form.autoThroughFriendFlag = row.autoThroughFriendFlag
      this.form.logoUrl = row.logoUrl
      this.form.remarks = row.remarks
      this.form.welcomeContent = row.welcomeContent
      Promise.all([getbindAccList(params), getSaleWeights(params)]).then(args => {
        const [r1, r2] = args
        if (r1.code === 0 && r1.data.length) {
          this.salesGroup = r1.data.map(item => {
            const sales = item.data.map(v => {
              return {
                userid: v.qwUserId,
                name: v.qwUserName,
                mobile: v.salePhone,
                alias: v.alias,
                status: v.status
              }
            })
            const workCycle = []
            if (item.workCycle) {
              const t = item.workCycle.split(',')
              t.forEach(i => {
                workCycle.push(Number(i))
              })
            }
            return {
              sales,
              workCycle,
              startTime: item.startTime,
              endTime: item.endTime
            }
          })
        }
        if (r2.code === 0 && r2.data.length) {
          this.weights = r2.data
        }
      }).finally(() => {
        this.serializeSales(true)
        this.dialogVisible = true
        this.$nextTick(() => {
          this.isChange = true
        })
      })
    },
    // 保存活码
    handleSave() {
      // 表单校验
      this.$refs.ruleform.validate(valid => {
        if (valid) {
          // 判断员工
          const sr = this.salesGroup.some(item => item.sales.length === 0)
          if (sr) {
            this.$message.warning('请选择员工!')
            return
          }
          // 判断工作周期
          const cr = this.salesGroup.some(item => item.workCycle.length === 0)
          if (cr) {
            this.$message.warning('请选择工作周期!')
            return
          }
          // 判断上线时间
          const tr = this.salesGroup.some(item => !item.startTime || !item.endTime)
          if (this.form.customerServiceType === 2 && tr) {
            this.$message.warning('请选择上线时间!')
            return
          }
          if (this.salesGroup[0].workCycle.length !== 7) {
            if (this.backSales.length === 0) {
              this.$message.warning('请选择备选人员!')
              return
            }
          }
          // 序列化客服人员参数
          const codeSales = this.salesGroup.map(item => {
            const saleIds = item.sales.map(item => item.userid)
            return {
              saleIds: saleIds.join(','),
              workCycle: item.workCycle.join(','),
              startTime: item.startTime,
              endTime: item.endTime
            }
          })
          const params = {
            ...this.form,
            codeSales
          }
          const [ backSale ] = this.backSales
          params.alternateSaleId = backSale.userid
          params.alternateSaleName = backSale.name
          if (this.form.addLimitFlag === 2) {
            // 序列化销售权重参数
            const saleAddLimits = this.sales.map(item => {
              return {
                saleId: item.userid,
                weight: item.weight
              }
            })
            params.saleAddLimits = saleAddLimits

          }
          params.classifyId = this.classifyId
          let tips = '是否确认保存活码'
          // 判断是否复制
          if (this.isCopy) {
            delete params.id
            if (this.isChange) {
              tips = '当前活码无任何修改，是否确认保存?'
            }
          }
          if (params.id) {
            tips = '是否确认修改并保存活码?'
          }

          this.$confirm(tips, '确认', {
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          }).then(() => {
            addQwLiveCode(params).then(({ code }) => {
              if (code === 0) {
                this.$message.success(this.form.id ? '修改成功!' : '保存成功!')
                this.$emit('close')
                this.handleClose()
              }
            })
          })
        } else {
          this.$message.warning('请检查表单!')
        }
      })
    },
    // 点击添加销售
    toAddAcc(index) {
      this.currentIndex = index
      if (this.salesGroup[index].sales && this.salesGroup[index].sales.length !== 0) {
        this.accSelection = this.salesGroup[index].sales
      }
      this.dialogAccVisible = true
      this.handleGetAccList()
    },
    // 点击添加备选人员
    toAddBackAcc() {
      this.currentIndex = 99999 // 标记是备选人员
      this.accSelection = this.backSales
      this.dialogAccVisible = true
      this.handleGetAccList()
    },
    delAcc(index) {
      this.salesGroup.splice(index, 1)
      this.serializeSales(false)
    },
    handleDelBackAcc() {
      this.backSales = []
    },
    // 获取销售列表
    handleGetAccList() {
      this.accLoading = true
      getAccList(this.accFilter).then(({ code, data }) => {
        if (code === 0) {
          this.accList = data.records
          this.accTotal = Number(data.total)
          this.$nextTick(() => {
            this.echo()
          })
        }
      }).finally(() => {
        setTimeout(() => {
          this.accLoading = false
        }, 300)
      })
    },
    handleFilter() {
      this.accFilter.page = 1
      this.handleGetAccList()
    },
    handleResetFilter() {
      this.accFilter = this.$options.data().accFilter
      this.handleGetAccList()
    },
    // 选择销售
    handleSelect(_, row) {
      if (this.currentIndex === 99999) { // 单选
        if (_.length > 1) {
          let del_row = _.shift()
          this.$refs.multipleTable.toggleRowSelection(del_row, false)
        }
        this.accSelection = [row]
      } else {
        // isExited判断selected是否已经存在当前项
        let isExited = false
        this.accSelection.forEach(item => {
          if(item.userid === row.userid) {
            isExited = true
          }
        })
        if (isExited) {
          // 若存在，代表操作是 取消选中
          this.handleDelItem(row)
        } else {
          // 反之，选中某项
          this.accSelection.push(row)
        }
      }
    },
    handleSelectionAll(selection) {
      if (selection.length === 0) {
        // 若是全不选，则循环删除selected数组中存在的项
        this.accList.forEach(item => {
          this.handleDelItem(item)
        })
      } else {
        // 全选，将selected和当前table数据合起来，注意去重！
        this.accSelection = unique(this.accSelection.concat(this.accList), 'userid')
      }
    },
    handleDelSelection ({ userid }) {
      const t = this.accList.find(item => item.userid === userid)
      if (t) {
        this.handleDelItem(t)
        this.$refs.multipleTable.toggleRowSelection(t, false)
      }
    },
    handleDelItem(row){
      let index = -1
      this.accSelection.forEach((item, idx) => {
        if(item.userid === row.userid) {
          index = idx
        }
      })
      if (index >= 0) {
        this.accSelection.splice(index, 1)
      }
    },
    echo() {
      let rows = []
      this.accList.forEach(row => {
        this.accSelection.forEach(item => {
          if (row.userid === item.userid) {
            rows.push(row)
          }
        })
      })
      this.toggleSelection(rows)
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 添加销售
    handleSaveAcc() {
      if (this.accSelection.length === 0) {
        this.$message.warning('请选择添加成员!')
        return
      }
      if (this.currentIndex === 99999) {
        if (this.accSelection.length > 1) {
          this.$message.warning('只能添加一个备选人员!')
          return
        }
        this.backSales = this.accSelection
        this.handleCloseAcc()
        return
      }
      this.salesGroup[this.currentIndex].sales = this.accSelection
      this.serializeSales(false)
      this.handleCloseAcc()
      this.isChange = false
    },
    // 删除销售
    handleDelAcc(index, i) {
      this.salesGroup[index].sales.splice(i, 1)
      this.serializeSales(false)
    },
    // 点击添加其他工作周期
    handleAddGroup() {
      this.salesGroup.push(group())
    },
    // 上传图片
    onUpload(url) {
      this.form.logoUrl = url
      this.isChange = false
    },
    serializeSales(init) {
      const t = this.salesGroup.reduce((pre, cur) => {
        return pre.concat(cur.sales)
      }, [])
      const r = t.map(item => {
        let weight = 1 // 默认
        if (init && this.weights && this.weights.length !== 0) { // 编辑回显
          const w = this.weights.find(v => v.saleId === item.userid)
          if (w) {
            weight = w.weight
          }
        }
        if (this.sales.length !== 0) { // 已手动编辑
          const a = this.sales.find(v => v.userid === item.userid)
          if (a) {
            weight = a.weight
          }
        }
        return { ...item, weight }
      })
      this.sales = unique(r, 'userid')
    },
    handleClose() {
      const d = this.$options.data()
      this.form = d.form
      this.salesGroup = d.salesGroup
      this.backSales = []
      this.sales = []
      this.total = 0
      this.weights = []
      this.dialogVisible = false
    },
    handleCloseAcc() {
      this.accList = []
      this.accSelection = []
      this.accFilter = this.$options.data().accFilter
      this.accTotal = 0
      this.currentIndex = 0
      this.$refs.multipleTable.clearSelection()
      this.dialogAccVisible = false
    },
    handleSizeChangeAcc(v) {
      this.accFilter.page = 1
      this.accFilter.limit = v
      this.handleGetAccList()
    },
    handleCurrentChangeAcc(v) {
      this.accFilter.page = v
      this.handleGetAccList()
    }
  }
}
</script>

<style lang="scss" scoped>
.form-dialog {
  ::v-deep .el-dialog__body {
    padding: 0 20px 20px;
    max-height: 80vh;
    overflow-y: auto;
  }
}
.form-module {
  width: 100%;
  .module-title {
    padding: 12px 0;
    border-bottom: 1px solid #E3E3E3;
    font-weight: 600;
    font-size: 14px;
  }
  ::v-deep .el-form {
    box-sizing: border-box;
    padding: 24px 12px;
  }
}
.item-explain {
  width: 100%;
  margin: 12px 0;
  box-sizing: border-box;
  padding: 12px;
  background-color: #DBEAFF;
  border: 1px solid #409EFF;
  border-radius: 4px;
}
.item-complement {
  width: 100%;
  margin: 12px 0;
  box-sizing: border-box;
  padding: 12px;
  background-color: #E4E4E4;
  border: 1px solid #9b9b9b;
  border-radius: 4px;
  .form-item-line {
    flex-wrap: wrap;
    .label {
      width: 72px;
    }
    .index-item {
      margin-right: 10px;
      margin-bottom: 6px;
    }
    & + .form-item-line {
      margin-top: 12px;
    }
  }
}
.pic {
  display: inline-block;
  width: 120px;
  height: 120px;
  margin-right: 12px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  .qr-logo {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 2px solid #FFFFFF;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &.preview {
    width: 100%;
    height: auto;
    margin: 0;
    .qr-logo {
      width: 98px;
      height: 98px;
      border-width: 6px;
      border-radius: 16px;
    }
  }
}
.preivew-dialog {
  ::v-deep .el-dialog__body {
    padding: 0;
  }
}
.upload-tips {
  font-size: 12px;
  color: #FF0000;
}
.radio-select-table {
  ::v-deep .el-table__header-wrapper .el-checkbox {
    //找到表头那一行，然后把里面的复选框隐藏掉
    display: none;
  }
}
.tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>
